import React from 'react';
import './style.css';
import logo from "../../assests/Logo/bg.png";
import qr from "../../assests/Logo/qr.jpeg";
import insta from "../../assests/Footer/insta.png";
import tik from "../../assests/Footer/tik.png";
import fb from "../../assests/Footer/fb.png";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <img src={qr} alt="Company Logo" className="qr-logo" />

        <div className="footer-left">
          <img src={logo} alt="Company Logo" className="footer-logo" />

          {/* <h2 className="logo">Innovation Solutions</h2> */}

          <p className="mission">
            <strong>Trusted construction. Total solutions.</strong><br />
            Your one-stop solution for every build.<br />
            From demolition to finishing touches.<br />
            Concrete, paint, tiles, electrical works, and tech — we handle it all.<br />
          </p>
        </div>

        <div className="footer-right">
          <h3 className="footer-section-title">Quick Links</h3>
          <ul className="footer-links">
            <li><a href="/">Home</a></li>
            <li><a href="/about-us">About Us</a></li>
            <li><a href="/our-services">Our Services</a></li>
            <li><a href="/gallery">Gallery</a></li>
            <li><a href="/contact-us">Contact Us</a></li>
          </ul>
        </div>

        <div className="footer-contact">
          <h3 className="footer-section-title">Contact</h3>
          <p><strong>Phone:</strong> +65 91005854</p>
          <p><strong>Email:</strong> sales@innovationsolutions.net</p>
          <p><strong>Location:</strong> Blk 301 Serangoon Ave 2 #01-334, Singapore</p>
         <div className="social-icons">
  <a 
    href="https://www.instagram.com/_innovation_solutions/" 
    target="_blank" 
    rel="noopener noreferrer"
  >
    <img src={insta} alt="Instagram" width={40} height={40} />
  </a>

  <a 
    href="https://www.facebook.com/profile.php?id=61583305064963" 
    target="_blank" 
    rel="noopener noreferrer"
  >
    <img src={fb} alt="Facebook" width={40} height={40} />
  </a>

  <a 
    href="https://www.tiktok.com/@_innovation_solutions" 
    target="_blank" 
    rel="noopener noreferrer"
  >
    <img src={tik} alt="TikTok" width={40} height={40} />
  </a>
</div>

        </div>


      </div>

      <div className="footer-bottom">

      </div>
    </footer>
  );
}

export default Footer;
